import styled from 'styled-components';

export const MainSupplierParts = styled.div``;

export const FooterSupplierParts = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;

    > button {
      margin: 1rem 0 0 0 !important;
      width: 100%;
      max-width: 100%;
    }
  }
`;

export const ContainerRemainingTime = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem 0rem;
`;
